<div 
  *ngIf="isInvalidToken" 
  class="invalid-token-message-container"
>
  <div class="invalid-token-message">
    <h2>{{ 'EVENT-PUBLIC-OVERVIEW.INVALID-LINK.TITLE' | translate }}</h2>
    <p>{{ 'EVENT-PUBLIC-OVERVIEW.INVALID-LINK.DESCRIPTION' | translate }}</p>
  </div>
</div>
<div
  *ngIf="!isInvalidToken && settings"
  class="training-overview" 
 >
  <div class="training-overview-card">
    <div class="training-location-image" *ngIf="logoUrl">
      <img [src]="logoUrl | safe: 'url'" />
    </div>
    <div class="training-overview-card-title">
      {{ settings.name }}
    </div>
    <div class="training-overview-card-subtitle">
      {{ settings.description }}
    </div>
    <app-panel>
      <div class="training-overview-container">
        <ng-container *ngIf="trainings?.length; else noTrainings">
          <div class="training-overview-filters">
            <div class="training-overview-filters-dropdown">
              <dx-drop-down-box
                [(value)]="filters.trainingCategories"
                [inputAttr]="{ 'aria-label': 'Owner' }"
                valueExpr="id"
                displayExpr="name"
                [label]="'COMMON.FIELDS.TRAINING-CATEGORIES' | translate"
                [dataSource]="trainingCategories"
                labelMode="floating"
                stylingMode="outlined"
              >
                <div *dxTemplate="let data of 'content'">
                  <dx-tree-view
                    [searchEnabled]="true"
                    [dataSource]="trainingCategories"
                    dataStructure="plain"
                    keyExpr="id"
                    selectionMode="multiple"
                    showCheckBoxesMode="normal"
                    [selectNodesRecursive]="false"
                    displayExpr="name"
                    [selectByClick]="true"
                    (onItemSelectionChanged)="onTrainingCategorySelected($event)"
                  >
                  </dx-tree-view>
                </div>
              </dx-drop-down-box>
              <dx-drop-down-box
                [(value)]="filters.eventTypes"
                [inputAttr]="{ 'aria-label': 'Owner' }"
                valueExpr="id"
                displayExpr="name"
                [label]="'COMMON.FIELDS.EVENT-TYPE' | translate"
                [dataSource]="eventTypes"
                labelMode="floating"
                stylingMode="outlined"
              >
                <div *dxTemplate="let data of 'content'">
                  <dx-tree-view
                    [searchEnabled]="false"
                    [dataSource]="eventTypes"
                    dataStructure="plain"
                    keyExpr="id"
                    selectionMode="multiple"
                    showCheckBoxesMode="normal"
                    [selectNodesRecursive]="false"
                    displayExpr="name"
                    [selectByClick]="true"
                    (onItemSelectionChanged)="onEventTypeSelected($event)"
                  >
                  </dx-tree-view>
                </div>
              </dx-drop-down-box>
            </div>
            <dx-text-box
              class="training-overview-search-input"
              icon="search"
              width="100%"
              labelMode="floating"
              stylingMode="outlined"
              [label]="'COMMON.SEARCH' | translate"
              [value]="filters.searchString"
              valueChangeEvent="input"
              (onValueChanged)="onSearchInput($event)"
            >
              <dxi-button
                name="search"
                type="danger"
                location="before"
                [options]="{ icon: 'search', type: 'default', disabled: true }"
              ></dxi-button>
            </dx-text-box>
          </div>
          <div class="training-card-container">
            <div *ngFor="let group of groupedTrainings" class="month-group">
              <h2 class="training-month">{{ group.month }}</h2>
              <div class="training-list">
                <div *ngFor="let training of group.items" class="training-card">
                  <app-public-training-overview-card
                    [training]="training"
                  ></app-public-training-overview-card>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noTrainings>
          <div class="no-trainings">
            {{ 'EVENT-PUBLIC-OVERVIEW.NO-TRAININGS' | translate }}
          </div>
        </ng-template>
      </div>
    </app-panel>
  </div>
</div>
